import { ApiLayer } from '@/utils/api/api-layer';
import axios from '@/utils/api/client/axios';
class OrderLayer extends ApiLayer {
    createOrder(data) {
        return this.methods.post(`/orders`, data);
    }
    fetchOrderList() {
        return this.methods.get(`/orders`);
    }
    fetchOrderTicket(number) {
        return this.methods.get(`/orders/${number}/ticket`, { responseType: 'blob' });
    }
    fetchOrderById(id) {
        return this.methods.get(`/orders/${id}`);
    }
    updateParticipants(id, data) {
        return this.methods.put(`/orders/${id}/participants`, data);
    }
    /**
     * Получение счета на оплату
     * @param id
     */
    fetchInvoiceById(id) {
        return this.methods.get(`/orders/${id}/invoice`, { responseType: 'blob' });
    }
}
export const OrderAPI = new OrderLayer(axios);
